import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import { TSmsStore, TSmsListResponsePayload, TSmsTypesResponsePayload } from './types';

export const getSmsState = (state: TStoreState): TSmsStore => state.sms;

// ==========================================:
// SMS list
export const getSmsList = createSelector([getSmsState], (sms: TSmsStore) => sms.smsList);

export const getSmsListData = createSelector(
	[getSmsList],
	(smsList: TSmsListResponsePayload) => smsList,
);

export const getSmsListLoading = createSelector(
	[getSmsState],
	(sms: TSmsStore) => sms.smsListLoading,
);

// ==========================================:
// SMS types
export const getSmsTypes = createSelector([getSmsState], (sms: TSmsStore) => sms.smsTypes);

export const getSmsTypesData = createSelector(
	[getSmsTypes],
	(smsTypes: TSmsTypesResponsePayload) => smsTypes,
);

export const getSmsTypesLoading = createSelector(
	[getSmsState],
	(sms: TSmsStore) => sms.smsTypesLoading,
);

// ==========================================:
// SMS send
export const getSmsSendLoading = createSelector(
	[getSmsState],
	(sms: TSmsStore) => sms.smsSendLoading,
);

export const getSmsSendSuccess = createSelector(
	[getSmsState],
	(sms: TSmsStore) => sms.smsSendSuccess,
);
